import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseUrlApi } from "../../../proxy";

/**
 * Home section content from Odoo. `undefined` while the request is in flight,
 * `null` once it failed — callers fall back to their static copy either way.
 * The `db` query param is added by the axios interceptor in proxy.ts.
 */
export function useSectionData<T>(path: string) {
  const { i18n } = useTranslation();
  const [data, setData] = useState<T | null | undefined>(undefined);

  useEffect(() => {
    const controller = new AbortController();
    setData(undefined);
    axios
      .get(`${baseUrlApi}portal/${path}`, {
        params: { lang: i18n.language },
        signal: controller.signal,
      })
      .then(({ data: body }) => setData(body?.result ?? body ?? null))
      .catch((error) => {
        if (!axios.isCancel(error)) setData(null);
      });
    return () => controller.abort();
  }, [path, i18n.language]);

  return data;
}

/** Odoo sends `false` for empty fields, so anything non-string is ignored. */
export const sectionText = (value: unknown) =>
  typeof value === "string" && value.trim() ? value.trim() : null;
